export default __webpack_public_path__ + "images/f8cecfb7efdd67db23efe4fe7d7c728c-softball_small.webp";